import { createFeatureSelector } from '@ngrx/store';
import type { DomainState } from './domain.state';

export const DOMAIN_NAME = 'domain_customDates';

export const domainState = createFeatureSelector<DomainState>(DOMAIN_NAME);
